import { render, staticRenderFns } from "./userWithdrawCar.vue?vue&type=template&id=2c593abc&scoped=true&"
import script from "./userWithdrawCar.vue?vue&type=script&lang=js&"
export * from "./userWithdrawCar.vue?vue&type=script&lang=js&"
import style0 from "./userWithdrawCar.vue?vue&type=style&index=0&id=2c593abc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c593abc",
  null
  
)

export default component.exports